module.exports = __webpack_public_path__ + "static/media/twilight-zone.32d68c7a.png";